export const PermissionNavigation = (navigation, permissions) => {
	return navigation?.filter((n) => {
		return permissions?.some((p) => n?.permissions?.includes(p?.id));
	});
};

export const Permission = (permission, permission_ids) => {
	return permission?.some((p) => permission_ids.includes(p?.id));
};
